document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-serum-page]').forEach(page=>{
    const images=[...page.querySelectorAll('[data-serum-image]')];
    const thumbs=[...page.querySelectorAll('[data-serum-thumb]')];
    const dots=[...page.querySelectorAll('[data-serum-dot]')];
    let activeImage=0;
    const showImage=index=>{
      activeImage=(index+images.length)%images.length;
      images.forEach((image,i)=>image.classList.toggle('is-active',i===activeImage));
      thumbs.forEach((item,i)=>item.classList.toggle('is-active',i===activeImage));
      dots.forEach((item,i)=>item.classList.toggle('is-active',i===activeImage));
    };
    thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>showImage(index)));
    page.querySelector('[data-serum-prev]')?.addEventListener('click',()=>showImage(activeImage-1));
    page.querySelector('[data-serum-next]')?.addEventListener('click',()=>showImage(activeImage+1));
    const gallery=page.querySelector('.serum-gallery__main');
    let touchStart=0;
    gallery?.addEventListener('touchstart',event=>{touchStart=event.touches[0].clientX;},{passive:true});
    gallery?.addEventListener('touchend',event=>{const distance=event.changedTouches[0].clientX-touchStart;if(Math.abs(distance)>45)showImage(activeImage+(distance<0?1:-1));},{passive:true});
    const resultItems=[...page.querySelectorAll('[data-serum-result]')];
    const resultStatus=page.querySelector('[data-serum-result-status]');
    let activeResult=0;
    const showResult=index=>{
      activeResult=(index+resultItems.length)%resultItems.length;
      resultItems.forEach((item,i)=>item.classList.toggle('is-active',i===activeResult));
      if(resultStatus)resultStatus.textContent=`${activeResult+1} / ${resultItems.length}`;
    };
    page.querySelector('[data-serum-result-prev]')?.addEventListener('click',()=>showResult(activeResult-1));
    page.querySelector('[data-serum-result-next]')?.addEventListener('click',()=>showResult(activeResult+1));
    const resultsGrid=page.querySelector('.serum-results-grid');
    let resultTouchStart=0;
    resultsGrid?.addEventListener('touchstart',event=>{resultTouchStart=event.touches[0].clientX;},{passive:true});
    resultsGrid?.addEventListener('touchend',event=>{const distance=event.changedTouches[0].clientX-resultTouchStart;if(Math.abs(distance)>45)showResult(activeResult+(distance<0?1:-1));},{passive:true});
    const form=page.querySelector('[data-serum-form]');
    const sticky=page.querySelector('[data-serum-sticky]');
    page.querySelectorAll('[name="id"]').forEach(input=>input.addEventListener('change',()=>{
      const label=input.closest('label');
      const price=label?.dataset.price;
      const title=label?.dataset.title;
      page.querySelectorAll('[data-serum-atc-price]').forEach(node=>node.textContent=price||'');
      if(sticky){sticky.querySelector('[data-serum-sticky-title]').textContent=title||'';sticky.querySelector('[data-serum-sticky-price]').textContent=price||'';}
    }));
    page.querySelector('[data-serum-buy]')?.addEventListener('click',()=>{
      let returnTo=form.querySelector('[name="return_to"]');
      if(!returnTo){returnTo=document.createElement('input');returnTo.type='hidden';returnTo.name='return_to';form.appendChild(returnTo);}
      returnTo.value='/checkout';
      form.requestSubmit();
    });
    page.querySelector('[data-serum-sticky-submit]')?.addEventListener('click',()=>page.querySelector('[data-serum-buy]')?.click());
  });
});
